var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { QuestionTypeName } from '../../classes/learnware/LearnwareEnums';
import { Choice } from '../Choice/Choice';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Question } from '../../classes/question/Question';
import { alias } from '../../utils/serializr/schema/middle/alias';
import { withInit } from '../../utils/serializr/schema/middle/withInit';
import { object } from '../../utils/serializr/schema/object';
import { disgardOldValue } from '../../utils/serializr/schema/middle/disgardOldValue';
import { primitive } from '../../utils/serializr/schema/inner/primitive';
import { MultipleChoiceStore } from './modules/MultipleChoiceStore';
import { MultipleChoiceScore } from './modules/MultipleChoiceScore';
import { MultipleChoiceAnsweringFeedback } from './modules/MultipleChoiceAnsweringFeedback';
import { editable } from '../../utils/mobx/decorators/editable';
export class QuestionMultipleChoice extends Choice {
    questionType = QuestionTypeName.MultipleChoice;
    MAX_OPTIONS = 100;
    get options() {
        return super.options;
    }
    get shuffledOptions() {
        return super.shuffledOptions;
    }
    get questionScore() {
        return new MultipleChoiceScore(this);
    }
    get answeringFeedback() {
        return new MultipleChoiceAnsweringFeedback(this);
    }
    get multipleChoiceStore() {
        return this.choiceStore;
    }
    static get serializeInfo() {
        return {
            extends: Question.serializeInfo,
            props: {
                questionType: withInit(primitive, QuestionTypeName.MultipleChoice),
                choiceStore: alias('questionTypeStore', withInit(object(MultipleChoiceStore), {})),
                textBasis: alias('text', disgardOldValue(primitive)),
            },
        };
    }
}
__decorate([
    editable()
], QuestionMultipleChoice.prototype, "questionType", void 0);
__decorate([
    memoize
], QuestionMultipleChoice.prototype, "questionScore", null);
__decorate([
    memoize
], QuestionMultipleChoice.prototype, "answeringFeedback", null);
__decorate([
    memoize
], QuestionMultipleChoice, "serializeInfo", null);
